module.exports = __webpack_public_path__ + "static/media/gwt_icon_store.191ba88d.png";